import { withHomeClaimFlow } from "../../traits";
import PersonalInfoStore from "../PersonalInfoStore";
import UIStore from "../UIStore";
import UserDataStore from "../UserDataStore";
import ValidationStore from "../ValidationStore";
import ValuationStore from "../ValuationStore";

class RootStore {
  constructor(context) {
    this.personalInfoStore = new PersonalInfoStore(context);
    this.uiStore = new UIStore(context);
    this.valuationStore = new ValuationStore(context);
    this.userDataStore = new UserDataStore(context);
    this.validationStore = new ValidationStore(context);
  }

  initialize(data) {
    this.personalInfoStore.initialize(data);
    this.uiStore.initialize(data);
    this.userDataStore.initialize(data);
    this.validationStore.initialize(data);
    this.valuationStore.initialize(data);

    this.setObservers();
  }
}

export default withHomeClaimFlow(RootStore);
